<template>
   <!-- <div :data-cy="`report-card-${report.report_type.key}`"></div> -->
  <Card :pt="{
        root: { 
      'data-cy': `report-card-${report.report_type.key}` 
    },
    content: {
      class: ['p-0']
    }
  }">
    <template #title>
      {{ report.name }}
    </template>
    <template #subtitle>{{ report.report_type.description }}</template>
    <template #footer >
      <div v-if="downloading" class="items-center justify-center shrink flex h-10">
        <ProgressSpinner class=" h-9 w-9" :stroke-width="5" />
      </div>
      <div v-else class="flex items-center justify-end space-x-4 h-10">
        <Button  :pt="{
           root: { 'data-cy': 'csv-button' }}" class="flex-1" :disabled="!report.report_type.csv" severity="secondary" outlined
                @click="downloadCsvReport" size="small">
          <template #icon>
            <IconCsv/>
          </template>
        </Button>
        <Button class="flex-1" :disabled="true || !report.report_type.html" severity="secondary" outlined
                @click="downloadHtmlReport" size="small">
          <template #icon>
            <IconHtml/>
          </template>
        </Button>
        <Button class="flex-1" :disabled="true || !report.report_type.pdf" severity="secondary" outlined
                @click="downloadPdfReport" size="small">
          <template #icon>
            <IconPdf/>
          </template>
        </Button>
      </div>
    </template>
  </Card>
</template>

<script>
import {IconCsv, IconDots, IconDownload, IconHtml, IconPdf} from "@tabler/icons-vue";
import {mapStores} from "pinia";
import {useReportsStore} from "@/stores/reports.js";
import {useDownloadLink} from "@/Composables/DownloadLink.js";

export default {
  name: "ReportCard",
  components: {
    IconCsv,
    IconDots,
    IconDownload,
    IconHtml,
    IconPdf,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      downloading: false,
    }
  },
  methods: {
    async downloadCsvReport() {
      try {
        this.downloading = true;
        const download = await this.reportsStore.showReport(this.report.id, {response_type: 'csv'});
        this.downloadCsvFileFromBlob([download], this.report.name);
      } catch (e) {
        console.log(e);
        this.$toast.add({
          severity: 'error',
          summary: this.$t('common.error'),
          detail: this.$t('widgets.cards.report_card.something_went_wrong_downloading_the_report'),
          life: 3000
        });
      } finally {
        this.downloading = false;
      }
    },
    downloadHtmlReport() {
      alert(this.$t('widgets.cards.report_card.html_not_yet_supported'));
    },
    downloadPdfReport() {
      alert(this.$t('widgets.cards.report_card.pdf_not_yet_supported'));
    },
    downloadCsvFileFromBlob(blob, filename = null) {
      let file = new Blob(blob, {type: 'text/csv'});
      let href = window.URL.createObjectURL(file);
      filename = filename.replace(/\.+$/, '_');
      filename = filename.replace(' ', '_');
      filename = `SUMS_${filename}_${Date.now().toString()}.csv`;

      useDownloadLink(href, {download: filename});
    },
  },
  computed: {
    ...mapStores(useReportsStore),
    menuOptions() {
      return [
        {
          visible: this.report.report_type?.csv === 1,
          label: this.$t('widgets.cards.report_card.download_csv'),
          icon: 'IconDownload',
          command: (e) => {
            this.downloadCsvReport()
          }
        },
        {
          visible: this.report.report_type?.html === 1,
          label: this.$t('widgets.cards.report_card.download_html'),
          icon: 'IconDownload',
          command: (e) => {
            this.downloadHtmlReport()
          }
        },
        {
          visible: this.report.report_type?.pdf === 1,
          label: this.$t('widgets.cards.report_card.download_pdf'),
          icon: 'IconDownload',
          command: (e) => {
            this.downloadPdfReport()
          }
        },
      ];
    }
  },
}
</script>

<style scoped>

</style>